<template>
	<div class="incenters" style="margin-left: 0px;">

		<div style="margin-left: 10px;">
			<div class="topstate" v-for="(item , index) of state" :key="index" :class="[{ 'ativte' : onchage == index}]"
				@click="tabClick(index)">
				{{ item.title }}
			</div>
		</div>
		<div>
			<Commonbtn v-if="addtype" backgroundColor="#FFF" :src="require('@/assets/icon/icon-add.png')" title="新增数据"
				fontSize="14px" @btnclick="addclick">
			</Commonbtn>
			<Commonbtn v-if="deltype" backgroundColor="#FFF" :src="require('@/assets/icon/del-j.png')" title="删除选中项"
				fontSize="14px" @btnclick="delclick">
			</Commonbtn>
			<template v-for="(item , index) of formdata">
				<Commondropdownlist v-if="inputtype" ref="outadd" @wCodeChage="wCodeChage" :loading="loading"
					:event="item.event" :key="index" :options="item.options" :minrigth="item.minrigth"
					:maxrigth="item.maxrigth" :minleft="item.minleft" :maxleft="item.maxleft"
					:lablewith="item.lablewith" :inputdata="item.inputdata" :title="item.title"
					:fontSize="item.fontSize" :color="item.color" :placeholder="item.placeholder" :types="item.types"
					:inputtype="item.inputtype" :width="item.width"></Commondropdownlist>
			</template>
		</div>
		<div v-if="tableflag" style="overflow-x: scroll;">
			<Commontable v-if="wtypestate" :loadingTable="loadingTable" @handleSelectionChange="handleSelectionChange"
				:rowhe="false" width="1000px" colnum=5 :tableData="tableDataDetailunNo" :headerData="headerData"
				height="100%"></Commontable>
			<Commontable v-if="!wtypestate" :loadingTable="loadingTable" :rowhe="false" width="1000px" colnum=7
				:tableData="tableDataDetail" :headerData="headerData"></Commontable>
		</div>
		<div width="1000px" v-if="tableflags">
			<Commontable @handleSelectionChange="handleSelectionChanges" @TaxUnitPriceChange="TaxUnitPriceChange"
				colnum=5 :Quantityflag="Quantityflag" :tableData="tableDataDetailUnique" :headerData="headerData"
				height="100%"></Commontable>
		</div>
		<DialogFrom width="1000px" title="选择商品" :dialogVisible="dialogVisibleSelectproduct"
			@cancel="cancelSelectproduct" @dialogOK="dialogOKcancelSelectproduct">
			<div class="from">
				<div class="inputtop" v-if="showorhide">
					<template v-for="(item , index) of fromdataadd">
						<Commondropdownlist ref="XZselect" @remoteMethodtows="remoteMethodtows" :loading="loading"
							:btx="item.btx" :key="index" :options="item.options" :minrigth="item.minrigth"
							:maxrigth="item.maxrigth" :minleft="item.minleft" :maxleft="item.maxleft"
							:lablewith="item.lablewith" :inputdata="item.inputdata" :title="item.title"
							:fontSize="item.fontSize" :color="item.color" :placeholder="item.placeholder"
							:types="item.types" :inputtype="item.inputtype" :width="item.width"></Commondropdownlist>
					</template>
					<div style="display: inline-block;float: right;margin-right: 0px;">
						<CommonBtngroup checktitle="仅显示大于0" marginRight="590px" :chackbox="true" :checked="true"
							:show="showorhide" ref="btngroup" @showclick="showclick" @hide="hide" @select="select"
							@reset="reset" :qhide="true"></CommonBtngroup>
					</div>
					<div style="height:10px;">
					</div>

				</div>
				<div class="inputtops" v-else>
					<div style="display: inline-block;" v-for="(item , index) of fromdataadd.slice(0,2)" :key="index">
						<Commondropdownlist ref="XZselect" @remoteMethodtows="remoteMethodtows" :loading="loading"
							:minrigth="item.minrigth" :maxrigth="item.maxrigth" :minleft="item.minleft"
							:maxleft="item.maxleft" :lablewith="item.lablewith" :inputdata="item.inputdata"
							:title="item.title" :fontSize="item.fontSize" :color="item.color"
							:placeholder="item.placeholder" :types="item.types" :inputtype="item.inputtype"
							:width="item.width"></Commondropdownlist>
					</div>
					<div style="display: inline-block;float: right;margin-right: 0px;">
						<CommonBtngroup ref="btngroup" :show="showorhide" @showclick="showclick" @hide="hide"
							@select="select" @reset="reset"></CommonBtngroup>
					</div>
					<div style="height:10px;">
					</div>
				</div>

				<div style="width: 970px;">
					<AddTable @AddhandleSelectionChange="AddhandleSelectionChange" width="1000px" colnum=7
						:tableData="tableDatas" :headerData="headerData" height="100%">
					</AddTable>
				</div>
				<div class="pagination">
					<Pagination @handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange"
						:total="total"></Pagination>
				</div>
			</div>
		</DialogFrom>
	</div>
</template>

<script>
	import Commontable from '../../../../components/common-table.vue'
	import Commonbtn from '../../../../components/common-btn.vue'
	import DialogFrom from '../../../../components/dialog-from.vue'
	import CommonBtngroup from '../../../../components/commongroup.vue'
	import Commondropdownlist from '../../../../components/common-dropdownlist.vue'
	import Pagination from '../../../../components/pagination.vue'
	import AddTable from '../components/components/addTable.vue'
	import fromdataadd from '../fromData/addlistfrom'
	import {
		WarehouseList,
		StockReportList,
		wmsDespatchDetailUnique,
		wmsDespatchDetail,
		StockReportUniqueInfo
	} from '@/api/home'
	export default {
		name: "AddDialogFromTable",
		components: {
			Commontable,
			Commonbtn,
			DialogFrom,
			CommonBtngroup,
			Commondropdownlist,
			AddTable,
			Pagination,
		},
		props: {
			dpmid: {
				type: String,
				default: ""
			},
			state: {
				type: Array,
				default: []
			},
			dialogindex: {
				type: String,
				default: ''
			},
			cusCode: {
				type: String,
				default: ''
			},
			// DetailTableList: {
			//   type: Array,
			// },
		},
		data: function() {

			return {
				fromdataadd: [],
				AddTableData: [],
				tableDataDetailunNo: [],
				AddTableSelectiondetailUniqueList: [],
				addtype: true,
				deltype: true,
				inputtype: false,
				tableflag: true,
				tableflags: false,
				Quantityflag: false,
				dialogVisibleSelectproduct: false,
				loadingTable: false,
				showorhide: true,
				wtype: 0,
				wtypestate: true,
				tableDatas: [],
				headerData: [{
						prop: 'id',
						label: '序号',
						columnwidth: 120
					},
					{
						prop: 'OHospitalName',
						label: '仓库',
						columnwidth: 117
					},
					{
						prop: 'InvAddCode',
						label: '商品代码',
						columnwidth: 117
					},
					{
						prop: 'InvName',
						label: '存货名称',
						columnwidth: 133
					},
					{
						prop: 'Batch',
						label: '批号',
						columnwidth: 110
					},
					// {
					//   prop: 'Batch',
					//   label: '唯一码',
					//   columnwidth: 180
					// },
					{
						prop: 'ValiDate',
						label: '有效期至',
						columnwidth: 102
					},
					{
						prop: 'Quantity',
						label: '数量',
						columnwidth: 82
					},
					{
						prop: 'TaxUnitPrice',
						label: '含税单价',
						columnwidth: 82,
					},
					{
						prop: 'Sum',
						label: '含税合计',
						columnwidth: 82,
					},
				],
				from: {
					whCode: "",
					invAddCode: "",
					batch: "",
				},
				formdata: [{
					inputdata: "",
					title: "扫描唯一码",
					fontSize: "14px",
					color: "#333333",
					placeholder: "请输入",
					types: "text",
					inputtype: "input",
					width: "180px",
					lablewith: "80px",
					btx: true,
					event: "wCodeChage"
				}, ],
				onchage: 0,
				tableflag: true,
				tableflags: false,
				pageSize: 20,
				PageIndex: 1,
				total: null,
				loading: true,
				tableDataDetail: [],
				tableDataDetailUnique: [],
				AddDialTableData: []
			}
		},
		created() {},
		mounted() {
			this.fromdataadd = JSON.parse(JSON.stringify(fromdataadd))
		},
		methods: {
			// 明细
			async wmsDespatchDetail() {
				let {
					data,
					code
				} = await wmsDespatchDetail({
					dpmid: this.dpmid
				})
				if (code == 0) {
					this.tableDataDetail = data
				}
			},
			// 唯一码
			async wmsDespatchDetailUnique() {
				let {
					data,
					code
				} = await wmsDespatchDetailUnique({
					dpmid: this.dpmid
				})
				if (code == 0) {
					this.tableDataDetailUnique = data
				}
			},
			tabClick(index) {
				if (index == 0) {
					this.wtype = 0
					if (this.wtypestate == false) {
						this.addtype = false
						this.deltype = false
						this.inputtype = false
					} else {
						this.addtype = true
						this.deltype = true
						this.inputtype = false
					}
					if (this.dialogindex == "update") {
						// this.wmsDespatchDetail()
					}
					this.tableflag = true
					this.tableflags = false
				}
				if (index == 1) {
					this.wtype = 1
					if (this.wtypestate == false) {
						this.addtype = false
						this.deltype = true
						this.inputtype = true
						this.Quantityflag = false
					}

					if (this.dialogindex == "update") {
						// this.wmsDespatchDetailUnique()
					}
					this.tableflag = false
					this.tableflags = true
				}
				if (this.onchage != index) {
					this.onchage = index
				}
			},
			// 仓库远程搜索
			async remoteMethodtows(query) {
				this.loading = true
				let {
					data,
					code
				} = await WarehouseList({
					whCode: query
				})
				if (code == 0) {
					this.loading = false
					this.fromdataadd[0].options = []
					data.data.map((item, index) => {
						let obj = {
							key: item.WHCode,
							value: item.WHName
						}
						this.fromdataadd[0].options.push(obj)
					})
				}
			},
			// 产品库列表
			async stockReportList() {
				//console.log(this.$parent.$children[5].modelvalue, 'this.$parent');
				const loading = this.$loading({
					lock: true,
					text: '正在加载列表...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let {
					data,
					code
				} = await StockReportList({
					// whCode: this.$parent.$children[5].modelvalue,
					invAddCode: this.from.invAddCode,
					batch: this.from.batch,
					isAboveZero: 1,
					cusCode: this.$parent.$children[3].modelvalue,
					PageSize: this.pageSize,
					PageIndex: this.PageIndex
				})
				if (code == 0) {
					this.total = data.Count
					this.tableDatas = data.data.map(item => {
						item.OHospital = item.Hospital;
						item.OHospitalName = item.HospitalName;
						return item;
					})
					loading.close();
				} else {
					loading.close();
				}
			},
			async stockReportUniqueInfo(e) {
				let {
					data,
					code
				} = await StockReportUniqueInfo({
					invUniqueCode: e
				})
				if (code == 0) {
					let num = parseInt(Math.random() * 10000)
					let obj = Object.assign({}, data, {
						ids: num
					})
					let falg = false
					for (let index in this.tableDataDetail) {
						if (this.tableDataDetail[index].Batch == data.Batch) {
							this.tableDataDetail[index].Quantity = this.tableDataDetail[index].Quantity + 1
							falg = true
						}
					}
					if (falg == false) {
						this.tableDataDetail.push(JSON.parse(JSON.stringify(obj)))
					}
					this.tableDataDetailUnique.push(JSON.parse(JSON.stringify(obj)))
				}
			},
			wCodeChage(e) {
				if (this.$parent.$children[10].modelvalue == '') {
					this.$message({
						type: "warning",
						message: "请选择产品线"
					})
					return
				}
				this.stockReportUniqueInfo(e)
				// //console.log(e);
			},
			TaxUnitPriceChange(par) {
				let val = par.e.target._value
				let row = par.row
				this.tableDataDetailUnique.map((item, index) => {
					if (item.Batch == row.Batch) {
						item.TaxUnitPrice = val
					}
				})
				this.tableDataDetail.map((item, index) => {
					if (item.Batch == row.Batch) {
						item.TaxUnitPrice = val
					}
				})
			},
			showclick() {
				this.showorhide = true
			},
			hide() {
				this.showorhide = false
				//console.log("askdas", this.showorhide)

			},
			addclick() {
				//console.log(this.$parent.$children, 'this.$parent.$children');
				if (this.$parent.$children[2].modelvalue == '') {
					this.$message({
						type: "warning",
						message: "请填写原经销商！"
					})
					return
				}
				if (this.$parent.$children[6].modelvalue == '') {
					this.$message({
						type: "warning",
						message: "请填写新经销商！"
					})
					return
				}
				if (this.$parent.$children[10].modelvalue == '') {
					this.$message({
						type: "warning",
						message: "请选择产品线！"
					})
					return
				}
				if (this.$parent.$children[5].modelvalue == '') {
					this.$message({
						type: "warning",
						message: "没有调出仓库！"
					})
					return
				}
				this.dialogVisibleSelectproduct = true
				this.stockReportList()
				this.$emit('addclick')
			},
			delclick() {
				if (this.$parent.$children[10].modelvalue == '') {
					this.$message({
						type: "warning",
						message: "请选择产品线"
					})
					return
				}
				if (this.wtype == 0) {
					var set = this.AddDialTableData.map(item => item.ID)
					var resArr = this.tableDataDetailunNo.filter(item => !set.includes(item.ID))
					this.tableDataDetailunNo = resArr
					var set = this.AddDialTableData.map(item => item.ID)
					var resArr = this.tableDataDetail.filter(item => !set.includes(item.ID))
					this.tableDataDetail = resArr
				} else {
					// 唯一码删除（根据唯一码数量加减更改明细）
					var set = this.AddTableSelectiondetailUniqueList.map(item => item.ID)
					var Batch = this.AddTableSelectiondetailUniqueList.map(item => item.Batch)
					for (var i = 0; i < Batch.length; i++) {
						for (var j = 0; j < this.tableDataDetail.length; j++) {
							if (Batch[i] == this.tableDataDetail[j].Batch) {
								this.tableDataDetail[j].Quantity = this.tableDataDetail[j].Quantity - 1
								if (this.tableDataDetail[j].Quantity <= 0) {
									this.tableDataDetail.splice(j, 1)
								}
							}
						}
					}
					var resArr = this.tableDataDetailUnique.filter(item => !set.includes(item.ID))
					this.tableDataDetailUnique = resArr
				}
			},
			select() {
				this.from.invAddCode = this.$refs.XZselect[0].modelvalue
				this.from.batch = this.$refs.XZselect[1].modelvalue
				this.stockReportList()
			},
			reset() {
				this.$refs.XZselect.map((item, index) => {
					item.modelvalue = ''
				})
			},
			cancelSelectproduct() {
				this.dialogVisibleSelectproduct = false
			},
			dialogOKcancelSelectproduct() {
				if (this.wtype == 0) {
					//console.log(this.AddTableData, this.tableDataDetailunNo);
					for (var i = 0; i < this.AddTableData.length; i++) {
						for (var j = 0; j < this.tableDataDetailunNo.length; j++) {
							if (this.AddTableData[i].Batch == this.tableDataDetailunNo[j].Batch && this.AddTableData[i]
								.InvAddCode == this.tableDataDetailunNo[j].InvAddCode) {
								this.$message({
									type: "warning",
									message: `不允许选择重复数据`
								})
								return
							} else {

							}
						}
					}
					this.AddTableData.map((item, index) => {
						this.tableDataDetailunNo.push(item)
						// this.tableDataDetail.push(item)
					})

					// let arr = []
					// let objDet = {}
					// this.tableDataDetailunNo.map((item, index) => {
					//   let num = parseInt(Math.random() * 10000)
					//   objDet = Object.assign({}, item, { ids: num })
					//   arr.push(objDet)
					// })
					// this.tableDataDetailunNo = arr
					// this.tableDataDetail = arr
				}
				if (this.wtype == 1) {
					for (var i = 0; i < this.AddTableData.length; i++) {
						for (var j = 0; j < this.tableDataDetail.length; j++) {
							if (this.AddTableData[i].ID == this.tableDataDetail[j].ID) {
								this.tableDataDetail.splice(j, 1);
							}
						}
					}
					this.AddTableData.map((item, index) => {
						this.tableDataDetailUnique.push(item)
					})
				}
				console.log(this.tableDataDetailunNo, 'tableDataDetailunNo');
				this.dialogVisibleSelectproduct = false
			},
			handleCurrentChange(pageindex) {
				this.PageIndex = pageindex
				this.stockReportList()
			},
			handleSizeChange(paegSzie) {
				this.pageSize = paegSzie
				this.stockReportList()
			},
			handleSelectionChange(val) {
				this.AddDialTableData = val
				this.$emit('handleSelectionChange', val)
			},
			handleSelectionChanges(val) {
				this.AddTableSelectiondetailUniqueList = val
			},
			AddhandleSelectionChange(val) {
				// if (val.length > 0) {
				console.log(val);
				this.AddTableData = val
				// }
			},

		},
		watch: {
			wtypestate: {
				handler(newData, oldData) {
					if (newData) {
						this.addtype = true
						this.deltype = true
						this.inputtype = false
					} else {
						if (this.onchage == 0) {
							this.addtype = false
							this.deltype = false
							this.inputtype = false
						} else {
							this.addtype = false
							this.deltype = true
							this.inputtype = true
						}
					}
				},
				deep: true
			}
		}
	}
</script>

<style lang="less" scoped>
	.ativte {
		border: 1px solid red;
		color: #e71d43;
		background-color: #fce8ec;
		transition: 0.2s linear;
	}

	.incenters {
		height: 100%;
		font-family: "微软雅黑";
		background-color: #fff;
		width: 970px;
		margin-top: 10px;
		padding-bottom: 10px;
		padding-top: 2px;

		div {
			margin-right: 10px;
			margin-top: 5px;
			margin-bottom: 5px;
			// width: 100%;
		}
	}

	.topstate {
		width: 100px;
		height: 32px;
		font-size: 14px;
		border: 1px solid #e6e6e6;
		line-height: 32px;
		text-align: center;
		cursor: pointer;
		display: inline-block;
	}

	.from {
		width: 100%;

		.inputtop {
			width: 960px !important;
			height: 40px;
			// box-shadow: 0px 1px 4px 0px rgba(56, 43, 43, 0.1);
			border-bottom: 1px solid #f0f0f0;
			background-color: #ffffff;
			padding-top: 15px;
			padding-bottom: 70px;
			animation: shows 0.2s linear;
			overflow: hidden;
		}

		.inputtops {
			width: 960px !important;
			height: 0;
			// box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);
			border-bottom: 1px solid #f0f0f0;
			background-color: #ffffff;
			padding-top: 15px;
			padding-bottom: 70px;
			overflow: hidden;
			// animation: hides 0.5s ease-in;
		}
	}

	@keyframes shows {
		0% {
			height: 0px;
		}

		100% {
			height: 40px;
		}
	}

	@keyframes hides {
		0% {
			opacity: 0;
			height: 40px;
		}

		100% {
			opacity: 1;
			height: 0px;
		}
	}
</style>